export default {
  common: {
    home: 'Home',
    workbench: 'Dashboard',
    search: 'Search',
    reset: 'Reset',
    empty: 'No data',
    emptyDesc: 'No records match your filters',
    loading: 'Loading…',
    viewMore: 'View more',
    mainNav: 'Main navigation',
    subNav: 'Sub navigation',
    subNavOpen: 'Open sub-menu',
    back: 'Back',
    detail: 'Detail',
    operation: 'Actions',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    export: 'Export',
    success: 'Success',
    failed: 'Failed',
    logout: 'Sign out',
    logoutConfirm: 'Are you sure you want to sign out?',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    pleaseInput: 'Please enter',
    pleaseSelect: 'Please select',
    startTime: 'Start date',
    endTime: 'End date',
    selectMonth: 'Select month',
  },
  field: {
    keywords: 'Keywords',
    personnel: 'Personnel',
    role: 'Role',
    status: 'Status',
    employment: 'Employment',
    sex: 'Gender',
    mobile: 'Mobile',
    email: 'Email',
    username: 'Username',
    realName: 'Name',
    deviceName: 'Device name',
    deviceCode: 'Asset no.',
    model: 'Model',
    manufacturer: 'Manufacturer',
    template: 'Template',
    code: 'Code',
    title: 'Title',
    points: 'Points',
    workHours: 'Total hours',
    kilometer: 'Mileage',
    initialWorkHours: 'Initial hours',
    initialKilometer: 'Initial mileage',
    maintenanceTime: 'Initial maintenance',
  },
  btn: {
    bindDevice: 'Bind device',
    unbind: 'Unbind',
    unlink: 'Remove',
    unlinkConfirm: 'Remove binding for {name}?',
    linkUser: 'Link operator',
    initPwd: 'Reset password',
    view: 'View',
    editDevice: 'Edit device',
  },
  table: {
    index: '#',
    operation: 'Actions',
  },
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled',
    onJob: 'Active',
    offJob: 'Left',
    available: 'Available',
    warehouse: 'Warehouse',
    unknown: 'Unknown',
    male: 'Male',
    female: 'Female',
  },
  detail: {
    device: 'Device detail',
    machinist: 'Operator detail',
    captain: 'Captain detail',
    workbenchDesc: 'Overview and pending tasks',
    recentClockIn: 'Recent clock-ins',
    recentPoints: 'Recent points',
    clockTime: 'Clock-in time',
    clockAddress: 'Address',
    deviceLabel: 'Device',
    monthWorkDays: 'Work days this month',
    monthOtDays: 'OT days this month',
    monthOtHours: 'OT hours this month',
    monthZhiDays: 'Mid-shift days this month',
    monthZhiHours: 'Mid-shift hours this month',
    basicInfo: 'Basic info',
    workTime: 'Work hours',
    tabMachinist: 'Operators',
    tabDevice: 'Devices',
    unitDay: 'days',
    unitHour: 'hrs',
    unitPoint: 'pts',
    score: 'Score',
  },
  dashboard: {
    stats: 'Business overview',
    quickLinks: 'Quick links',
    workbenchTitle: 'Today\'s workbench',
    workbenchType: 'Type',
    workbenchItem: 'Item',
    workbenchSubmitter: 'Submitter',
    workbenchTime: 'Time',
    workbenchAction: 'Action',
    workbenchEmpty: 'No pending items',
    workbenchMaintenance: 'Maintenance',
    workbenchSpecial: 'Special task',
    workbenchImprove: 'Skills',
    workbenchAnomaly: 'Anomaly',
    workbenchOvertime: 'OT today',
    workbenchApprove: 'Approve',
    workbenchReject: 'Reject',
    workbenchConfirmTitle: 'Confirm audit',
    maintenanceAudit: 'Maintenance pending',
    specialAudit: 'Special tasks pending',
    improveAudit: 'Skills pending',
  },
  improveDetail: {
    title: 'Detail',
    taskName: 'Task name',
    score: 'Score',
    staffLimit: 'Staff limit',
    unlimited: 'Unlimited',
    taskDesc: 'Task description',
    taskMaterial: 'Task materials',
    submitter: 'Submitter',
    submitPhotos: 'Submitted photos',
    submitContent: 'Submitted content',
    auditComment: 'Audit comment',
    passStatus: 'Approved',
    close: 'Close',
    passed: 'Passed',
    rejected: 'Rejected',
    opSuccess: 'Operation succeeded',
    opFailed: 'Failed',
  },
  salary: {
    generate: 'Generate payslips',
    export: 'Export payslips',
    editTitle: 'Edit payslip',
    month: 'Month',
    name: 'Name',
    employment: 'Employment',
    totalEarnings: 'Gross pay',
    allowance: 'Allowance',
    deduction: 'Deductions',
    mpfDeduction: 'MPF deduction',
    incomeAfterMpf: 'Income after MPF',
    netPay: 'Net pay',
    remarks: 'Remarks',
    clockDays: 'Clock-in days',
    annualLeaveDays: 'Paid leave days',
    otDays: 'OT days',
    otHours: 'OT hours',
    zhiDays: 'Mid-shift days',
    zhiHours: 'Mid-shift hours',
    tongxiaoDays: 'Overnight days',
    weekendDays: 'Weekend days',
    nightShiftDays: 'Night shift days',
    allowancePlaceholder: 'Enter allowance',
    deductionPlaceholder: 'Enter deduction',
    remarksPlaceholder: 'Enter remarks',
    loadFailed: 'Failed to load payslips',
    selectMonthFirst: 'Please select a month first',
    selectMonth: 'Please select a month',
    generateConfirmTitle: 'Confirm generation',
    generateConfirmBody: 'This will regenerate payslips for {month}. Existing data and manual edits will be overwritten. Continue?',
    generateConfirmOk: 'Generate',
    generateSuccess: 'Generated successfully',
    generateFailed: 'Generation failed',
    exportFailed: 'Export failed',
    editSuccess: 'Saved successfully',
    editFailed: 'Save failed',
    exportFileName: 'payslips-{month}.xls',
  },
  attendance: {
    recordTitle: 'Clock-in records',
    export: 'Export',
    exportSummary: 'Export summary',
    exportDetail: 'Export details',
    clockType: 'Clock type',
    clockIn: 'Clock in',
    clockOut: 'Clock out',
    onMachine: 'On-machine',
    offMachine: 'Off-machine',
    ot: 'OT',
    zhongzhi: 'Mid-shift',
    shiftType: 'Shift',
    dayShift: 'Day shift',
    nightShift: 'Night shift',
    status: 'Status',
    normal: 'Normal',
    late: 'Late',
    earlyLeave: 'Early leave',
    missing: 'Missing',
    abnormalLocation: 'Abnormal location',
    loadFailed: 'Failed to load',
    exportFailed: 'Export failed',
    selectTimeRange: 'Please select a time range',
    selectMonth: 'Please select a month',
    overtimeTime: 'Overtime time',
    overtimeDuration: 'Overtime hours',
    workContent: 'Work content',
    location: 'Location',
    projectSite: 'Project site',
    clockDays: 'Clock-in days',
    otDays: 'OT days',
    otHours: 'OT hours',
    zhiDays: 'Mid-shift days',
    zhiHours: 'Mid-shift hours',
    tongxiaoDays: 'Overnight days',
    nightShiftDays: 'Night shift days',
    lateCount: 'Late count',
    earlyLeaveCount: 'Early leave count',
    signTime: 'Signature time',
    signImage: 'Signature image',
    audit: 'Review',
    pendingAudit: 'Pending review',
    captainApproved: 'Captain approved',
    captainRejected: 'Captain rejected',
    adminApproved: 'Admin approved',
    adminRejected: 'Admin rejected',
    leaveType: 'Type',
    leave: 'Leave',
    annualLeave: 'Annual leave',
    startDate: 'Start date',
    endDate: 'End date',
    days: 'Days',
    reason: 'Reason',
    createdAt: 'Created at',
    captainReviewHint: 'Only super admin can review captain clock-ins',
    annualLeaveBalance: 'Annual leave balance',
    machinistInfo: 'Operator info',
    leaveYear: 'Year',
    yearPlaceholder: 'e.g. 2026',
    startDateOnJob: 'Start date',
    currentYearDays: 'Available days (read-only)',
    carryoverDays: 'Carryover days',
    totalAnnualDays: 'Total annual leave',
    usedAnnualDays: 'Used days',
    remainAnnualDays: 'Remaining days',
    remark: 'Remarks',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    clockRemind: 'Clock-in reminder',
    clockLocation: 'Clock-in location',
    annualLeaveRule: 'Annual leave rules',
    makeupDate: 'Make-up date',
    makeupTime: 'Make-up time',
    makeupType: 'Make-up type',
    anomalyReason: 'Reason',
    locationName: 'Location name',
    locationDesc: 'Description',
    longitude: 'Longitude',
    latitude: 'Latitude',
    addressId: 'Address ID',
    manualRecord: 'Manual clock-in',
    manualRecordTitle: 'Batch manual attendance entry',
    manualRecordSelectCaptain: 'Select captain',
    manualRecordSelectCaptainFirst: 'Select a captain first',
    manualRecordTeamList: 'Team list (includes captain)',
    manualRecordMachinistList: 'Operator list',
    manualRecordNoTeam: 'No team members under this captain',
    manualRecordNoMachinist: 'No operators under this captain',
    manualRecordNoDevice: 'No device bound',
    manualRecordSelectDevice: 'Select device',
    manualRecordDeviceRequired: 'Select a device for each selected person',
    manualRecordSelectMachinist: 'Select at least one person',
    manualRecordOnTime: 'Clock-in time',
    manualRecordOffTime: 'Clock-out time',
    manualRecordDefaultOn: 'Default 08:30',
    manualRecordDefaultOff: 'Default 18:00',
    manualRecordTypes: 'Entry type',
    manualRecordTypeRequired: 'Select at least clock-in or clock-out',
    manualRecordAddressPlaceholder: 'Optional, defaults to admin entry',
    manualRecordHint: 'After selecting a captain, the list includes the captain and their operators. Each person can choose a bound device (default: latest). People without devices cannot be selected. Existing same-day records of the same type will be updated.',
    manualOtRecordTitle: 'Batch manual OT / straight-shift entry',
    manualOtRecordCheckinTime: 'Clock-in time',
    manualOtRecordDefaultTime: 'Default 18:00',
    manualOtRecordTypes: 'Entry type',
    manualOtRecordTypeRequired: 'Select at least OT or straight shift',
    manualOtRecordOtHours: 'OT hours',
    manualOtRecordContentsPlaceholder: 'Optional, defaults to admin entry',
    manualOtRecordHint: 'After selecting a captain, the list includes the captain and their operators. Each person can choose a bound device. Straight shift is fixed at 1 hour. Existing same-day records of the same type will be updated.',
    configure: 'Configure',
    notMaintained: 'Not set',
    annualLeaveRuleLink: 'Tenure and annual leave days (per tenant)',
    machinist: 'Operator',
    captainReview: 'Captain clock-in review',
    clockReview: 'Clock-in review',
    recentTwoDays: 'Last 2 days',
    history: 'History',
    noClockRecords: 'No clock-in records',
    evaluated: 'Reviewed',
    pendingEvaluate: 'Pending review',
    noRecord: 'No record',
    none: 'None',
    reviewAndEvaluate: 'Review & evaluate',
    captainEvaluate: 'Captain evaluation',
    evaluateContent: 'Comments',
    evaluateContentPlaceholder: 'Enter comments',
    reject: 'Reject',
    pass: 'Approve',
    complaint: 'Complaint',
    submitReview: 'Submit review',
    onlySuperAdminSubmit: 'Only super admin can submit reviews',
    missingReviewTarget: 'Missing review target or date',
    cannotGetCurrentUser: 'Cannot get current user',
    reviewSubmitSuccess: 'Review submitted',
    reviewSubmitFailed: 'Review submission failed',
    efficiencyPass: 'Efficiency approved',
    attitudePass: 'Attitude approved',
    constructionPass: 'Construction feedback approved',
    hasComplaint: 'Complaint filed',
    noContent: 'No content',
    captainName: 'Captain name',
    placeholderNameUserMobile: 'Name / username / mobile',
    otZhongzhiClock: 'OT / mid-shift',
    onMachineColon: 'On-machine:',
    offMachineColon: 'Off-machine:',
    otColon: 'OT:',
    zhongzhiColon: 'Mid-shift:',
    evaluateColon: 'Review:',
    viewDuration: 'View duration',
    seconds: 'seconds',
    craneRemind: 'Crane clock-in notice',
    excavatorRemind: 'Excavator clock-in notice',
    enterCraneRemind: 'Enter crane clock-in notice',
    enterExcavatorRemind: 'Enter excavator clock-in notice',
    enterViewDuration: 'Enter view duration',
    defaultRulesWarning: 'No custom rules saved for this tenant. The table below shows system defaults. Click Save config to apply per tenant.',
    ruleInfoTitle: 'Configure tenure (anniversary years) and annual leave days per cycle. Each cycle starts on the hire anniversary (12 months). The top tier applies to that anniversary and above.',
    addRule: 'Add rule',
    restoreDefault: 'Restore defaults',
    saveConfig: 'Save config',
    serviceYears: 'Tenure (anniversary years)',
    annualDaysInCycle: 'Annual leave days per cycle',
    description: 'Notes',
    ruleTextPlaceholder: 'Optional; auto-generated if empty',
    fullYears: 'After',
    yearsAndAbove: 'years and above',
    yearsAnniversary: 'years',
    confirmRestoreDefault: 'Restore system default rules (not saved yet). Continue?',
    restoreDefaultTitle: 'Restore defaults',
    keepOneRule: 'Keep at least one rule',
    invalidAnniversary: 'Enter a valid anniversary year',
    invalidAnnualDays: 'Enter annual leave days',
    rowInvalidPrefix: 'Row {row}:',
  },
  attendanceDialog: {
    anomalyAuditTitle: 'Attendance anomaly review',
    annualLeaveAuditTitle: 'Leave / annual leave review',
    recordDetailTitle: 'Clock record detail',
    signDetailTitle: 'Signature detail',
    payslipDetailTitle: 'Payslip detail',
    clockLocationTitle: 'Clock location',
    auditRemark: 'Review comment',
    auditRemarkPlaceholder: 'Enter review comment',
    auditResult: 'Decision',
    relatedPhotos: 'Photos',
    signerName: 'Signer name',
    signImage: 'Signature image',
    signedAt: 'Signed at',
    locationName: 'Name',
    locationDesc: 'Description',
    selectAddress: 'Pick on map',
    openGoogleMaps: 'Open Google Maps',
    enterLongitude: 'Enter longitude',
    enterLatitude: 'Enter latitude',
    longitudeRange: 'Longitude must be between -180 and 180',
    latitudeRange: 'Latitude must be between -90 and 90',
    leaveTypeAnnual: 'Annual leave',
    leaveTypeNormal: 'Leave',
    timeRange: 'Period',
    annualLeavePay: 'Paid annual leave (daily rate)',
    attendanceNote: 'Attendance note',
    sundayOtDays: 'Sunday OT days',
    reloginRequired: 'Please sign in again',
    auditSuccess: 'Review submitted',
    auditFailed: 'Review failed',
    hourSuffix: 'h',
  },
  maintenance: {
    back: 'Back',
    templateLabel: 'Template',
    addPart: 'Add part',
    addProject: 'Add maintenance item',
    edit: 'Edit',
    audit: 'Review',
    detail: 'Detail',
    submitRecord: 'Submission records',
    deviceCode: 'Asset no.',
    deviceName: 'Device name',
    model: 'Model',
    status: 'Status',
    pending: 'Pending',
    pendingAudit: 'Awaiting review',
    completed: 'Completed',
    overdue: 'Overdue',
    rejected: 'Rejected',
    loadFailed: 'Failed to load',
    planProject: 'Maintenance item',
    planContent: 'Maintenance content',
    requiredMaterials: 'Required materials',
    dose: 'Dose per unit',
    frequencyType: 'Frequency type',
    fixedCycle: 'Fixed cycle',
    driveKm: 'Drive distance',
    workHoursType: 'Work hours',
    days: 'Days',
    km: 'Kilometers',
    hours: 'Hours',
    enable: 'Enabled',
    disable: 'Disabled',
    close: 'Close',
    partName: 'Part name',
    scheduleDate: 'Scheduled date',
    assignee: 'Assignee',
    materials: 'Materials',
    submitInfo: 'Submission',
    auditStatus: 'Audit status',
    pass: 'Approved',
    reject: 'Rejected',
    needPartName: 'Enter part name',
    editPart: 'Edit part',
  },
  maintenanceDuplicate: {
    month: 'Month',
    deviceId: 'Device ID',
    duplicateCount: 'Duplicate count',
    duplicateMachinists: 'Duplicate machinists',
    firstCheckTime: 'First selection',
    lastCheckTime: 'Latest selection',
    loadFailed: 'Failed to load',
  },
  deviceDetail: {
    title: 'Device detail',
    editDevice: 'Edit device',
    tabInfo: 'Overview',
    tabWorkTime: 'Work hours',
    codeColon: 'Asset no.',
    modelColon: 'Model',
    totalHoursColon: 'Total hours',
    kmColon: 'Mileage',
    totalWorkHours: 'Total work hours',
    hourUnit: 'h',
  },
  maintenanceAudit: {
    title: 'Maintenance review',
    partName: 'Part name',
    maintenanceContent: 'Maintenance task',
    scheduleDate: 'Scheduled date',
    assignee: 'Assignee',
    materials: 'Attachments',
    submitInfo: 'Submission notes',
    auditStatus: 'Review decision',
    pass: 'Approve',
    reject: 'Reject',
  },
  personnelDialog: {
    linkMachinist: 'Link operator',
    personnel: 'Personnel',
    captain: 'Captain',
    bindDevice: 'Bind device',
    device: 'Device',
    selectDevice: 'Select device',
    selectRequired: 'Please select',
  },
  deviceForm: {
    template: 'Template',
    fullPhoto: 'Full photo',
    nameplatePhoto: 'Nameplate photo',
    workKm: 'Mileage',
    initialWorkKm: 'Initial mileage',
    addKmTitle: 'Add mileage',
    kmToAdd: 'Mileage to add',
  },
  personnelDetail: {
    recentCheckin: 'Recent check-ins',
    recentPoints: 'Recent points',
    points: 'Points',
    monthCheckinDays: 'Check-in days this month',
    monthOtDays: 'OT days this month',
    monthOtHours: 'OT hours this month',
    monthZhiDays: 'Mid-shift days this month',
    monthZhiHours: 'Mid-shift hours this month',
    tabMachinist: 'Machinist',
    tabCaptain: 'Captain',
    noData: 'No data',
  },
  personnelList: {
    captainSearch: 'Captain',
    machinistSearch: 'Machinist',
    searchPlaceholder: 'Name / username / mobile / email',
    linkMachinist: 'Link machinist',
    bindDevice: 'Bind device',
    editMachinist: 'Edit machinist',
    addMachinist: 'Add machinist',
    editCaptain: 'Edit captain',
    addCaptain: 'Add captain',
    captainSelect: 'Captain',
    captainSelectPh: 'Select captain',
    captainSelectRequired: 'Please select a captain',
    roleMachinist: 'Machinist',
    roleCaptain: 'Captain',
    resetPwd: 'Reset password',
    colId: 'ID',
    colCaptainId: 'Captain ID',
    colIndex: 'No.',
    colName: 'Name',
    colEnglishName: 'English name',
    colIdCard: 'ID number',
    colSex: 'Gender',
    colUsername: 'Username',
    colPassword: 'Password',
    colEmail: 'Email',
    colAddress: 'Address',
    colStartDate: 'Start date',
    colEndDate: 'End date',
    colEmployment: 'Employment',
    colMobile: 'Mobile',
    colPoints: 'Points',
    colStatus: 'Status',
    colLoginTime: 'Last login',
    colOperation: 'Actions',
    employmentActive: 'Active',
    employmentInactive: 'Inactive',
    sexUnknown: 'Unknown',
    sexMale: 'Male',
    sexFemale: 'Female',
    statusDisabled: 'Disabled',
    statusEnabled: 'Enabled',
    importMachinist: 'Batch import',
    importMachinistTitle: 'Import machinists',
    importMachinistTip: 'Download the template, fill it in, then upload. Captain ID is the ID shown on the Captain list. Default password is 123456. Only creates new machinists and links captains.',
    importDownloadTemplate: 'Download template',
    importDragTip: 'Drop Excel here or click to select .xls / .xlsx',
    importSubmit: 'Import',
    importSelectFile: 'Please select an Excel file first',
    importTemplateFailed: 'Template download failed',
    importColRow: 'Row',
    importColStatus: 'Result',
    importColMessage: 'Message',
    importSuccess: 'OK',
    importFailed: 'Failed',
  },
  feedbackList: {
    keywordLabel: 'Title keyword',
    titleLabel: 'Title',
    typeLabel: 'Type',
    statusLabel: 'Status',
    reporterLabel: 'Reporter',
    reply: 'Reply',
    colId: 'Feedback ID',
    colTitle: 'Title',
    colStatus: 'Status',
    colType: 'Type',
    colReporter: 'Reporter',
    colContent: 'Content',
    colContact: 'Contact',
    colCreatedAt: 'Created at',
    statusDone: 'Resolved',
    statusPending: 'Pending',
    typeSuggestion: 'Suggestion',
    typeBug: 'Bug report',
    typeUsage: 'Usage issue',
    typeOther: 'Other',
  },
  feedbackReply: {
    title: 'Feedback reply',
    reporter: 'Reporter',
    contact: 'Contact',
    content: 'Feedback',
    relatedImages: 'Images',
    replyContent: 'Reply',
    needReply: 'Enter reply',
    replySuccess: 'Reply sent',
  },
  platformRenewal: {
    tip: 'Open or renew shared SaaS tenants here. Monthly (1/3/6) or yearly (1–5 years). New tenants must be opened before login. See Subscription logs for history.',
    keywords: 'Keywords',
    keywordsPh: 'Tenant code / name',
    renew: 'Renew',
    open: 'Open',
    renewTitle: 'Renew tenant',
    openTitle: 'Open tenant',
    tenant: 'Tenant',
    currentExpire: 'Current expiry',
    durationType: 'Duration type',
    byMonth: 'Monthly',
    byYear: 'Yearly',
    months: 'Months',
    month1: '1 month',
    month3: '3 months',
    month6: '6 months',
    years: 'Years',
    yearSuffix: ' yr',
    expireCalc: 'Expiry calculation',
    renewFromToday: 'Recalculate expiry from today',
    hintMonth: 'If unchecked, add selected months to current expiry (or from today if expired)',
    hintYear: 'If unchecked, extend from original open date',
    remark: 'Remark',
    remarkPh: 'Optional',
    colTenantCode: 'Tenant code',
    colTenantName: 'Tenant name',
    colYears: 'Current term',
    colOpenedAt: 'Opened at',
    colExpireAt: 'Expires at',
    colStatus: 'Status',
    colOperation: 'Actions',
    monthlyOrUnset: 'Monthly / unset',
    selectDuration: 'Select duration type',
    selectMonths: 'Select 1 / 3 / 6 months',
    selectYears: 'Select years',
  },
  platformLogs: {
    tip: 'Read-only history of tenant open/renew events.',
    keywordsPh: 'Tenant code / name / operator',
    eventOpen: 'Open',
    eventRenew: 'Renew',
    monthly: 'Monthly',
    yearSuffix: ' yr',
    colTenantCode: 'Tenant code',
    colTenantName: 'Tenant name',
    colEventType: 'Type',
    colYears: 'Term',
    colOpenedAt: 'Start date',
    colExpireBefore: 'Expiry before',
    colExpireAfter: 'Expiry after',
    colOperator: 'Operator',
    colRemark: 'Remark',
    colCreatedAt: 'Time',
    loadFailed: 'Failed to load',
  },
  loginPage: {
    tagline: 'Smart construction equipment platform',
    headline: 'Connect field and HQ',
    headline2: 'Manage machinists efficiently',
    feature1: 'GPS attendance & payslips',
    feature2: 'Maintenance plans & reminders',
    feature3: 'Tasks & mobile sync',
    register: 'Register',
    forgotPwd: 'Forgot password?',
    tenantLoginTitle: 'Tenant admin login',
    tenantLoginSubtitle: 'Enter tenant code and admin credentials',
    tenantCode: 'Tenant code',
    tenantCodePh: 'e.g. test2',
    tenantCodeRequired: 'Tenant code is required',
    usernameRequired: 'Username is required',
    passwordRequired: 'Password is required',
    loginBtn: 'Sign in',
    passwordLabel: 'Password',
    platformAdminDenied: 'This account cannot sign in via tenant portal',
    adminAccountPh: 'Admin username',
    mobile: 'Mobile',
    mobilePh: 'Enter mobile number',
    verificationCode: 'Verification code',
    codePh: 'Enter code',
    sendCode: 'Send code',
    accountPassword: 'Password',
    passwordPh: 'Enter password',
    confirmPassword: 'Confirm password',
    confirmPasswordPh: 'Re-enter password',
    changePasswordBtn: 'Change password',
    backToLogin: 'Have an account? Back to sign in',
    codeRequired: 'Verification code is required',
    confirmPasswordRequired: 'Please confirm password',
    superadminPageTitle: 'Platform admin',
    superadminPageDesc: 'Manage tenant lifecycle, subscriptions, and global settings.',
    superFeature1: 'Tenant lifecycle & subscriptions',
    superFeature2: 'Global API & system parameters',
    superFeature3: 'Secure multi-tenant data model',
    portalBadge: 'Platform Admin',
    portalTitle: 'Platform admin',
    portalDesc: 'Sign in to {brand} — manage tenants and global config',
    adminUsernamePh: 'Platform admin account',
    rememberUsername: 'Remember username',
    backTenantLogin: 'Back to tenant login',
    notPlatformAdmin: 'Not a platform admin — use tenant login',
  },
  dashboardHome: {
    statMachinist: 'Operators',
    statCaptain: 'Captains',
    statDevice: 'Devices',
    statMaintenance: 'Maintenance tasks',
    statSpecialTask: 'Special tasks',
    statImprove: 'Skill programs',
    statUsers: 'Users',
    quickAttendance: 'Clock records',
    quickUsers: 'User management',
    quickDevice: 'Equipment',
    quickMaintenance: 'Maintenance',
    chartMachinist: 'Operators',
    chartCaptain: 'Captains',
    chartDevice: 'Devices',
    chartMaintenance: 'Maint.',
    chartSpecialTask: 'Special',
    chartImprove: 'Skills',
    chartUsers: 'Users',
    demoTodaySales: 'Today sales',
    demoGrowth: 'growth',
    demoTodayPurchase: 'Today purchases',
    demoTodayFlow: 'Today turnover',
    demoSalesStatus: 'Sales overview',
    demoPartnerStats: 'Partner stats',
    demoSupplier: 'Suppliers',
    demoPurchaseStatus: 'Purchasing',
  },
  scoreLottery: {
    tabConfig: 'Draw settings',
    tabPrize: 'Prizes',
    pointsPerDraw: 'Points per draw',
    pointsTip: 'Total points ÷ this value = available draws (minus used)',
    saveConfig: 'Save settings',
    addPrize: 'Add prize',
    probSum: 'Enabled probability sum: ',
    probOver: '(exceeds 100%, adjust)',
    colSort: 'Sort',
    colLevel: 'Level',
    colLevelName: 'Level name',
    colPrizeName: 'Prize name',
    colProbability: 'Probability',
    colStatus: 'Status',
    editPrize: 'Edit prize',
    addPrizeTitle: 'Add prize',
    winProbability: 'Win probability',
    probHint: '0–1, e.g. 0.01 = 1%',
    levelNamePh: 'e.g. First prize',
    prizeNamePh: 'Prize name',
    needLevel: 'Enter level',
    needPrizeName: 'Enter prize name',
    needProbability: 'Enter win probability',
    pointsMinWarning: 'Points per draw must be greater than 0',
    deleteTitle: 'Confirm delete',
    deleteConfirm: 'Delete prize "{name}"? Levels with draw history cannot be deleted.',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
  },
  scoreRule: {
    addRule: 'Add',
    levelName: 'Level name',
    requiredPoints: 'Points required',
    needLevelName: 'Enter level name',
    needRequiredPoints: 'Enter points required',
  },
  scoreReward: {
    addProduct: 'Add item',
    itemName: 'Item name',
    itemDesc: 'Description',
    itemImage: 'Image',
    needItemName: 'Enter item name',
    needItemDesc: 'Enter description',
    needImage: 'Upload an image',
  },
  scoreRedemption: {
    add: 'Add',
    nameKeyword: 'Name keyword',
    user: 'User',
    consumedPoints: 'Points spent',
    redemptionTime: 'Redeemed at',
    redeemItem: 'Redeem item',
    needUser: 'Select a user',
    needReward: 'Select an item to redeem',
  },
  scoreLotteryRecord: {
    userName: 'Name',
    account: 'Account',
    pointsTier: 'Points tier',
    redeemStatus: 'Redemption',
    drawTime: 'Draw time',
    redeemed: 'Redeemed',
    notRedeemed: 'Not redeemed',
    keywordPlaceholder: 'Name / account',
  },
  scoreRemind: {
    usageGuide: 'Points usage guide',
    needContent: 'Enter points usage guide',
  },
  platformAdmin: {
    tenantsTip: 'Manage tenant profiles and admin accounts. Use Tenant renewal for SaaS renewals; see Subscription logs for history.',
    addTenant: 'Add tenant',
    editTenant: 'Edit tenant',
    tenantCode: 'Tenant code',
    tenantName: 'Tenant name',
    deployType: 'Deploy type',
    sharedSaas: 'Shared (SaaS)',
    standalone: 'Standalone',
    enable: 'Enable',
    disable: 'Disable',
    notOpened: 'Not opened',
    expired: 'Expired',
    notSet: 'Not set',
    sharedDefault: '(shared default)',
    edit: 'Edit',
    yearsSuffix: ' yr',
  },
  systemSetting: {
    title: 'System parameters',
    toScore: 'Clock-in points',
    offScore: 'Clock-out points',
    goToWork: 'Clock-in time',
    goOffWork: 'Clock-out time',
    otScore: 'OT / mid-shift points',
    maintenanceScore: 'Maintenance completion points',
    radius: 'Valid check-in radius (m)',
    complaintDeduction: 'Complaint deduction',
    nightShiftExtra: 'Night shift daily bonus (HKD)',
    tongxiaoMultiplier: 'Overnight pay multiplier (daily rate)',
    restoreDefault: 'Restore defaults',
    save: 'Save',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    loadFailed: 'Failed to load',
    pleaseSelect: 'Please select',
    defaultNightShift: 'Default 100',
    defaultTongxiao: 'Default 1.00',
  },
  menu: {
    home: 'Home',
    attendance: 'Attendance',
    attendanceList: 'Clock records',
    overtime: 'OT / Mid-shift',
    Summary: 'Attendance summary',
    salary: 'Payslips',
    clockIn: 'Clock locations',
    sign: 'Signatures',
    clockRemind: 'Clock notice',
    attendanceAnomaly: 'Anomalies',
    attendanceAnnualLeave: 'Leave / annual leave',
    attendanceAnnualLeaveBalance: 'Annual leave balance',
    attendanceAnnualLeaveRule: 'Tenure & annual leave days',
    attendanceCaptainReview: 'Captain review',
    equipment: 'Equipment',
    deviceTemplate: 'Device templates',
    equipmentList: 'Device list',
    deviceWorkTimeStats: 'Work hours stats',
    deviceUtilization: 'Utilization comparison',
    maintenanceRecord: 'Maintenance records',
    deviceDuplicateRecord: 'Duplicate device picks',
    task: 'Special tasks',
    specialTask: 'Special tasks',
    specialTaskSubmitRecord: 'Submissions',
    captainTask: 'Special tasks',
    captainSpecialTask: 'Special tasks',
    captainSpecialTaskSubmitRecord: 'Submissions',
    captainMaintenance: 'Maintenance tasks',
    captainMaintenanceSubmitRecord: 'Submissions',
    improve: 'Skill improvement',
    improveTask: 'Task list',
    improveTaskSubmitRecord: 'Submissions',
    score: 'Points',
    scoreRule: 'Point rules',
    scoreRecord: 'Point records',
    rewardRecord: 'Redemptions',
    rewardRemind: 'Points guide',
    lottery: 'Lottery',
    lotteryRecord: 'Lottery history',
    feedback: 'Feedback',
    system: 'System',
    userList: 'Users',
    setting: 'Parameters',
    brandSetting: 'Branding',
    ChangePsw: 'Change password',
    message: 'Messages',
    operationLogs: 'Audit log',
    machinist: 'Operators',
    captainMachinist: 'Operators',
    Captain: 'Captains',
    maintenance: 'Maintenance plans',
    'machinist-detail': 'Operator detail',
    'captain-detail': 'Captain detail',
    'device-detail': 'Device detail',
    platformTenants: 'Tenants',
    platformTenantRenewal: 'Renewals',
    platformTenantLogs: 'Subscription history',
    platformVersionControl: 'Version control',
  },
  deviceList: {
    add: 'Add',
    addKm: 'Add mileage',
    workDuration: 'Work hours',
    loadFailed: 'Failed to load',
  },
  taskSubmit: {
    recordId: 'Record ID',
    taskName: 'Task name',
    submitterName: 'Submitter name',
    submitterUsername: 'Submitter username',
    submitterMobile: 'Submitter mobile',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    statusNotSubmitted: 'Not submitted',
    statusPending: 'Pending review',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    auditStatus: 'Review status',
    pass: 'Approve',
    reject: 'Reject',
    keywordTaskOrName: 'Task name or submitter',
    missingRecordId: 'Missing submission record ID',
    loadDetailFailed: 'Failed to load details',
    invalidRecordId: 'Invalid record ID. Close and try again.',
  },
  improveList: {
    ended: 'Ended',
    taskId: 'Task ID',
    startTime: 'Start',
    endTime: 'Deadline',
  },
  improveSubmit: {
    statusInProgress: 'In progress',
    statusPass: 'Approved',
    statusFail: 'Rejected',
    material: 'Materials',
    reportContent: 'Report',
  },
  systemPersonnel: {
    roleNormalAdmin: 'Admin',
    roleSuperAdmin: 'Super admin',
  },
  systemAccount: {
    title: 'Account settings',
  },
  changePassword: {
    title: 'Change password',
    oldPwd: 'Current password',
    newPwd: 'New password',
    confirmPwd: 'Confirm password',
    oldPwdPh: 'Enter current password',
    newPwdPh: 'Enter new password',
    confirmPwdPh: 'Re-enter new password',
    pwdMismatch: 'Passwords do not match',
    submit: 'Submit',
    needOld: 'Enter current password',
    needNew: 'Enter new password',
    needConfirm: 'Re-enter new password',
    success: 'Password updated',
    failed: 'Update failed',
  },
  brandSetting: {
    systemName: 'System name',
    systemNamePh: 'e.g. Tenant admin portal',
    logo: 'Logo',
    logoTip: 'Applies to the top bar after login',
    themeColor: 'Theme color',
    recommended: 'Recommended',
    previewTitle: 'System name preview',
    headerPreview: 'Header preview',
    remark: 'Brand remark',
    remarkPh: 'Optional tenant admin note',
    save: 'Save branding',
    saveSuccess: 'Saved',
    saveSynced: 'Saved and branding updated',
    saveFailed: 'Save failed',
    loadFailed: 'Failed to load',
    imageOnly: 'Images only',
    logoUploaded: 'Logo uploaded and applied',
  },
  deviceTemplate: {
    keyword: 'Keyword',
    templateId: 'Template ID',
    templateName: 'Template name',
    templateIntro: 'Description',
    maintenancePlan: 'Maintenance plan',
  },
  deviceWorkTime: {
    tip: 'Hours from clock records (8h clock-out, OT/mid-shift/overnight rules apply).',
    utilizationTip: 'Utilization = monthly total hours ÷ ((days in month − 4) × 8h) × 100%. Over 100% indicates overtime/multi-shift beyond single-shift baseline.',
    exportExcel: 'Export Excel',
    exportFailed: 'Export failed',
    selectMonth: 'Select month',
    operatorDetail: 'Operator breakdown',
    workTimeDetail: 'Work time detail',
    allDevices: 'All devices',
    withHoursOnly: 'With hours only',
    allSites: 'All sites',
    scope: 'Scope',
    sort: 'Sort',
    sortDesc: 'High → low utilization',
    sortAsc: 'Low → high utilization',
    month: 'Month',
    site: 'Site',
    primarySite: 'Primary site',
    workDays: 'Work days',
    operatorCount: 'Operators',
    standardTime: 'Clock-out (h)',
    otTime: 'OT (h)',
    zhiTime: 'Mid-shift (h)',
    tongxiaoTime: 'Overnight (h)',
    totalTime: 'Total (h)',
    totalHours: 'Total hours',
    rank: 'Rank',
    utilizationRate: 'Utilization',
    baselineHours: 'Baseline (h)',
    loadFailed: 'Failed to load',
    trendRange: 'Trend range',
    trendMonths: 'Work hours trend ({n} months)',
    monthsSuffix: ' mo',
    viewMonth: 'View month',
    operatorBreakdown: 'Operator hours',
    emptyMonth: 'No records this month',
    missingDeviceMonth: 'Missing device or month',
    close: 'Close',
    machinist: 'Operator',
    clockOutShort: 'Clock-out (h)',
    otShort: 'OT (h)',
    zhiShort: 'Mid-shift (h)',
    tongxiaoShort: 'Overnight (h)',
    totalShort: 'Total (h)',
  },
  userForm: {
    addTitle: 'Add user',
    accountRemark: 'Account note',
    accountRemarkPh: 'Purpose of this account, e.g. finance, device admin',
    resignationRemark: 'Resignation note',
    resignationRemarkPh: 'Enter resignation note',
    dailyPay: 'Daily pay',
    hourlyPay: 'Hourly pay',
    allowance: 'Allowance',
    menuPermission: 'Menu permissions',
    restoreDefaultMenus: 'Restore defaults',
    selectAllMenus: 'Select all',
    clearMenus: 'Clear',
    menuPermissionTip: 'Normal admins exclude User list by default; check menus as needed.',
    superAdminTip: 'Super admins have all menus; no separate config needed.',
    needUsername: 'Enter username',
    needEnglishName: 'Enter English name',
    needIdCard: 'Enter ID number',
    needAddress: 'Enter address',
    phUsername: 'Enter username',
    phEnglishName: 'Enter English name',
    phIdCard: 'Enter ID number',
    phAddress: 'Enter address',
    phRealName: 'Enter name',
    phMobile: 'Enter mobile',
    phEmail: 'Enter email',
  },
  versionControl: {
    tip: 'Shared mobile app version config for all tenants.',
    androidVersion: 'Android version',
    iosVersion: 'iOS version',
    androidUrl: 'Android update URL',
    iosUrl: 'iOS update URL',
    compulsory: 'Force update',
    compulsorySwitch: 'Mandatory',
    versionPh: 'e.g. 1.0.0',
    urlPh: 'https://...',
    androidUrlPh: 'Android update URL',
    iosUrlPh: 'iOS update URL',
    versionInputPh: 'Enter version',
    needAndroidVersion: 'Enter Android version',
    needIosVersion: 'Enter iOS version',
    needIosUrl: 'Enter iOS update URL',
    needAndroidUrl: 'Enter Android update URL',
    needCompulsory: 'Select force update',
    clear: 'Clear',
  },
  systemLegacy: {
    apply: 'Apply',
    applyHistory: 'Application history',
    link: 'Link',
    buyer: 'Buyer',
    creditCode: 'Credit code',
    socialCreditCode: 'Unified social credit code',
    applyDate: 'Application date',
    attachment: 'Attachment',
    selectFile: 'Select file',
    preview: 'Preview',
    templateCode: 'Template code',
    paperType: 'Paper type',
    paperNormal: 'Standard',
    paperHalf: 'Half',
    paperThird: 'Third',
    uploadTime: 'Uploaded at',
    orgStructure: 'Organization',
    roleAdd: 'Add role',
    roleName: 'Role name',
    roleAttr: 'Attribute',
    roleId: 'Role ID',
    roleNameLabel: 'Role name',
    roleSearchName: 'Role name',
    permAssign: 'Assign permissions',
    printTemplate: 'Print templates',
    purchaseOrder: 'Purchase order',
    selectTemplate: 'Select template',
    selectColumn: 'Select',
    paperShape: 'Paper size',
    templateCount: 'Template count',
    buyerCol: 'Buyer',
    authorize: 'Authorize',
    basicInfo: 'Basic info',
    productAuth: 'Product authorization',
    nextStep: 'Next',
    productCategory: 'Category',
    productCode: 'Product code',
    productName: 'Product name',
    manufacturer: 'Manufacturer',
    spec: 'Spec',
    serialNo: 'Serial no.',
  },
  taskSpecial: {
    add: 'Add',
    titleKeyword: 'Title keyword',
    publisher: 'Publisher',
    published: 'Published',
    unpublished: 'Draft',
    unlimited: 'Unlimited',
    expired: 'Expired',
    taskId: 'Task ID',
    description: 'Description',
    staffLimit: 'Staff limit',
    startTime: 'Start',
    endTime: 'End',
    assignMember: 'Assign staff',
    auditTask: 'Review task',
    participants: 'Participants',
    members: 'Staff',
    staffPh: 'Staff limit; 0 = unlimited',
    endTimeOptionalPh: 'Leave blank for no expiry',
    needTitle: 'Enter title',
    needDesc: 'Enter description',
    needUpload: 'Upload materials',
    needStartTime: 'Select start time',
    needEndTime: 'Select end time',
    needScore: 'Enter score',
    needStaff: 'Enter staff limit',
    needStatus: 'Select status',
    imageOnly: 'Images only!',
  },
  scoreRecord: {
    recordId: 'Record ID',
    recorderName: 'Name',
    recorderUsername: 'Username',
    recorderMobile: 'Mobile',
    reason: 'Reason',
    points: 'Points',
    keywordPlaceholder: 'Name / username / mobile',
    time: 'Date range',
    createdAt: 'Created at',
  },
  auditLog: {
    tip: 'API errors and denied access (403/4xx/5xx) for troubleshooting permissions and endpoints.',
    method: 'Method',
    path: 'Path',
    httpStatus: 'HTTP status',
    errorMsg: 'Error',
    operator: 'User',
    operatedAt: 'Time',
    keywordPlaceholder: 'Path / username / name',
    loadFailed: 'Failed to load',
  },
  messageAdmin: {
    add: 'Add message',
    edit: 'Edit message',
    addBtn: 'Add message',
    messageType: 'Message type',
    typeSystem: 'System notice',
    typeReminder: 'Reminder',
    typeAnnouncement: 'Announcement',
    colType: 'Type',
    colTitle: 'Title',
    colContent: 'Content',
    colCreatedAt: 'Created at',
    titlePh: 'Enter title',
    contentPh: 'Enter content',
    typePh: 'Select type',
    needType: 'Select message type',
    needTitle: 'Enter title',
    titleLength: 'Title must be 1–100 characters',
    needContent: 'Enter content',
    contentLength: 'Content must be 1–1000 characters',
    deleteConfirm: 'Delete this message?',
    deleteTitle: 'Confirm delete',
    deleteNeedBackend: 'Delete requires backend support. Contact developers.',
    retryFailed: 'Operation failed. Try again.',
  },
  notFound: {
    title: 'Page not found',
    desc: 'This page does not exist or was removed.',
    backHome: 'Back to home',
  },
}
